$(function () {
  const $accordionItems = $('.faqs-accordion .accordion .accordion-item .accordion-collapse');

  if ($accordionItems.length > 0) {
    // Sets accordion-item active class to set background-color only in open one
    $accordionItems.each(function () {
      const $el = $(this);

      $el[0].addEventListener('hide.bs.collapse', function () {
        $el.parent().removeClass('active');
      });

      $el[0].addEventListener('show.bs.collapse', function () {
        $el.parent().addClass('active');
      });
    });
  }
});
